/**
 * Web build of env.ts — picked up automatically by webpack's `.web.ts` resolution
 * priority (see webpack.config.js resolve.extensions). LOCAL DEV TOOLING ONLY.
 *
 * The dev server proxies `/api/*` to http://localhost:8888 (see webpack.config.js
 * devServer.proxy), so the browser build talks to the SAME origin it's served from —
 * no CORS, no LAN IP to hardcode. `env.ts` (native) currently has an unrelated
 * temp hardcode for a standalone-APK LAN test; that file is untouched and irrelevant
 * here since this file wins for any web bundle.
 */
export const API_BASE_URL = '/api/v1';

/**
 * Единый вход (central SSO) — ВРЕМЕННО ОТКАЧЕН на относительный `/auth/*`.
 *
 * SSO делает `/auth/*` КРОСС-origin (cabinet → sso.sam-vision.uz), а web-кабинет
 * шлёт `credentials: 'same-origin'` (см. api/index.ts credentialsInit) — на
 * кросс-origin браузер тогда не сохраняет и не шлёт сессионную куку: логин
 * проходил (200), но следующий `/auth/me` уходил без токена → 401 → вход не
 * открывался (прод-авария 2026-09-15). Пока фронт не переведёт cookie-режим на
 * `credentials: 'include'`, `/auth/*` остаётся относительным (same-origin через
 * vhost → контурный гейтвей): вход работает. После `include` — вернуть SSO.
 */
export const SSO_BASE_URL = API_BASE_URL;
